import { useState, useMemo } from "react"
import { debounce } from "lodash"
import { useDeepCompareEffect } from "@/components/Form/formUtils"
import isEqual from "lodash/isEqual"

export default function useDebouncedHandleChange( iData, iHandleChange ) {
  const [data, setData] = useState(iData || null)

  useDeepCompareEffect(()=>{
    !isEqual(data, iData) && setData(iData)
  },[iData])

  const handleChange = useMemo(
    () => {
      const debouncedHandleChange = debounce(
        (path, value) => {
          iHandleChange(path, value) // Sends only the last value
        },
        300,
        { leading: false, trailing: true },
      )

      return (path, value) => {
        setData(value)
        debouncedHandleChange(path, value)
      }
    },
    [iHandleChange],
  )
  return {data, handleChange}
}